import PersonalPageFavoriteProject from'./PersonalPageFavoriteProject'
export default PersonalPageFavoriteProject